import { render, staticRenderFns } from "./FeatureGroupsForm.vue?vue&type=template&id=55e07753&"
import script from "./FeatureGroupsForm.vue?vue&type=script&lang=js&"
export * from "./FeatureGroupsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports